import { actionTypes } from "../Actions/gerenciarEntregas.action";

const initialState = {
  deliveries: {
    data: [],
  },
  delivery: {},
  success: false,
  error: {},
};

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        deliveries: {
          ...state.deliveries,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          data: state.deliveries.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        delivery: {
          ...state.delivery,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
